import { z } from 'zod';
export const createIntegrationSchema = z.object({
    type: z.enum(['zapier', 'ghl', 'spark', 'keap', 'zenplanner', 'kicksite', 'mystudio']),
    location_id: z.string().uuid().optional(),
    config: z.record(z.unknown()).optional(),
    credentials: z.record(z.unknown()).optional(),
});
export const adapterResultSchema = z.object({
    success: z.boolean(),
    externalId: z.string().optional(),
    statusCode: z.number().optional(),
    error: z.string().optional(),
    retryable: z.boolean(),
    latencyMs: z.number(),
});
export const createTagMappingSchema = z.object({
    source_page_slug: z.string().max(500).optional(),
    source_crm_tag: z.string().max(100).optional(),
    crm_tag_value: z.string().max(200),
    crm_field_name: z.string().max(100),
}).refine(data => data.source_page_slug || data.source_crm_tag, {
    message: 'Either source_page_slug or source_crm_tag is required',
});
//# sourceMappingURL=integration.js.map